import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  Validators,
} from "@angular/forms";
import moment from "moment";
import { ActivatedRoute } from "@angular/router";
import {MatDialog} from '@angular/material/dialog';

import { ApiCallService } from "../../../api/service/api-call.service";
import { ValidationService } from "src/app/services/validation.service";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import * as Constants from "../../../constant/Constants";
import { English, Kiswahili } from 'src/app/assets/strings/TZ/localization';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.css']
})
export class ClaimComponentTZ implements OnInit {

  // Url Params
  locale: string = "en";  // en || sw (Language)
  token: string = "placeholder-value"; // to validate the public accesses.
  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  LanguagePack: any = English;
  minDate: Date;
  maxDate: Date;

  formErrors: { [key: string]: string } = {
    reg: "",
    date: "",
    location: "",
    email: "",
    phone: "",
  };

  validationMessages: { [key: string]: {[key: string]: string} } = {
    reg: { required: this.LanguagePack.requiredValidation, pattern: this.LanguagePack.regValidation },
    date: { required: this.LanguagePack.requiredValidation },
    location: { required: this.LanguagePack.requiredValidation },
    email: { required: this.LanguagePack.requiredValidation, email: this.LanguagePack.emailValidation },
    phone: { required: this.LanguagePack.requiredValidation },
  };

  motorForm = this._formBuilder.group({
    reg: ["", [Validators.required, Validators.pattern(/^T\d{3}[A-Z]{3}$/)]],
    date: [moment(null), Validators.required],
    location: ["", Validators.required],
    email: ["", [Validators.required, Validators.email]],
    phone: ["", Validators.required],
  });

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private apiCallService: ApiCallService,
    private validationService: ValidationService,
  ) {
    const currentDate = new Date();
    const maxCov = new Date(currentDate.getTime());
    const minCov = new Date(currentDate.getTime());

    minCov.setFullYear(currentDate.getFullYear()-0.038356164383561644);
    maxCov.setFullYear(currentDate.getFullYear());

    this.minDate = minCov;
    this.maxDate = maxCov;
  }

  loading: boolean = false;
  url: string = environment.baseUrl + Constants.claimTZ_URL;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;

      if (params["locale"] !== undefined) {
        this.locale = params["locale"];
        // Change to Swahili language
        if (params["locale"] === "sw") {
          this.LanguagePack = Kiswahili;
  
          this.validationMessages = {
            reg: { required: this.LanguagePack.requiredValidation, pattern: this.LanguagePack.regValidation },
            date: { required: this.LanguagePack.requiredValidation },
            location: { required: this.LanguagePack.requiredValidation },
            email: { required: this.LanguagePack.requiredValidation, email: this.LanguagePack.emailValidation },
            phone: { required: this.LanguagePack.requiredValidation },
          };
        }
      }
    });
    
    this.motorForm.valueChanges.subscribe((form) => {
      this.logErrors();

      if (form.reg) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          reg: form.reg.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
    });
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
    );
  }

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      reg: this.motorForm.controls["reg"].value,
      date: this.motorForm.controls["date"].value!.format("DD-MM-YYYY"),
      location: this.motorForm.controls["location"].value,
      email: this.motorForm.controls["email"].value,
      phone: this.motorForm.controls["phone"].value,

      token: this.token,
      filled: true,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        // Auto-close the breakout page
        window.close();
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          this.LanguagePack.submissionFailed,
          this.LanguagePack.savingError,
          this.LanguagePack.cancel,
          this.LanguagePack.tryAgain
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      this.initDialogData(
        this.LanguagePack.submissionFailed,
        this.LanguagePack.unexpectedError,
        this.LanguagePack.cancel,
        this.LanguagePack.tryAgain
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
    
  }

  submitForm(): void {
    this.initDialogData(
      this.LanguagePack.confirmSubmission,
      this.LanguagePack.proceedDesc,
      this.LanguagePack.back,
      this.LanguagePack.proceed
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  confirmCancel() {
    this.initDialogData(
      this.LanguagePack.warning,
      this.LanguagePack.confirmCancel,
      this.LanguagePack.backSmallCaps,
      this.LanguagePack.cancelApplication
    );

    this.showGenericPopup(this.cancelApplication);
  }
  
  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Auto-close the breakout page
        window.close();

      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          this.LanguagePack.cancelFailed,
          this.LanguagePack.cancelNope,
          this.LanguagePack.cancel,
          this.LanguagePack.tryAgain
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      this.initDialogData(
        this.LanguagePack.cancelFailed,
        this.LanguagePack.cancelError,
        this.LanguagePack.cancel,
        this.LanguagePack.tryAgain
      );

      this.showGenericPopup(this.cancelApplication);
    }
  }

}
